import { Row, Col } from 'antd';
import { FloatingFormItem, InputDecimal } from '../..';
import SectionCard from '../../SectionCard';

interface Props {
  prefixPath?: string[];
}

export default function CbsFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  return (
    <>
      <h1>CBS - Contribuição sobre Bens e Serviços</h1>

      {/* ===== CBS (UB55..UB67) ===== */}
      <SectionCard visible title="CBS" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota (%)"
              name={[...prefixPath, 'cbsAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          {/* <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Redução de Alíquota (%)"
              name={[...prefixPath, 'cbsReductionAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota Efetiva (%)"
              extra={
                <Popover
                  overlayInnerStyle={{ width: 250 }}
                  content="Se informado, prevalece sobre 'Alíquota CBS' - 'Redução de Alíquota CBS'"
                >
                  <a>Informação</a>
                </Popover>
              }
              name={[...prefixPath, 'cbsEffectiveAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Percentual do diferimento (%)"
              name={[...prefixPath, 'cbsDeferralPercentage']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Diferimento"
              name={[...prefixPath, 'cbsDeferralValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Tributo Devolvido (cashback)"
              name={[...prefixPath, 'cbsTaxReturned']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col> */}

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor (auto)"
              name={[...prefixPath, 'cbsValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>
    </>
  );
}
